import $ from 'jquery'

export let preloader_absolute_hide = (preloader_id) => {
    $(preloader_id + " .status").fadeOut(100);
    $(preloader_id).delay(5).fadeOut(150);
}

export let preloader_absolute_show = (preloader_id) => {
    $(preloader_id+" .status").show();
    $(preloader_id).show();
}

export const current_lang = () => {
    return $('html').attr('lang');
};

export const current_lang_short = () => {
    const lang = current_lang() || "en";
    const dashIndex = lang.indexOf('-');
    return dashIndex !== -1 ? lang.substring(0, dashIndex) : lang;
};

export const datatable_lang_path = () => {
    const lang = (current_lang_short() || "en").toLowerCase();
    return "/langs/datatables/" + lang + ".json";
};

export const apexcharts_lang_file = () => {
	const lang = (current_lang_short() || 'en').toLowerCase();
	const tryLoad = (langCode) => $.ajax({
		url: "/langs/apexcharts/" + langCode + ".json",
		dataType: 'json',
		async: false,
		cache: false
	}).responseJSON;

	let value = tryLoad(lang);

	if (!value && lang !== 'en') {
		value = tryLoad('en');
	}

	return value;
};

let _commonLangFileCache = null;
let _commonLangFileFetched = false;

export const common_lang_file = () => {
	if (!_commonLangFileFetched) {
		_commonLangFileFetched = true;
		const lang = (current_lang_short() || 'en').toLowerCase();
		const tryLoad = (langCode) => $.ajax({
			url: "/langs/common/" + langCode + ".json",
			dataType: 'json',
			async: false,
			cache: false
		}).responseJSON;

		_commonLangFileCache = tryLoad(lang);

		if (!_commonLangFileCache && lang !== 'en') {
			_commonLangFileCache = tryLoad('en');
		}

		if (!_commonLangFileCache) {
			_commonLangFileCache = {};
		}
	}
	return _commonLangFileCache;
};

export const kFormatter = (num) => {
    var value = Math.sign(num)*Math.abs(num);
    if (value >= 1000000)
    {
        value = Math.sign(num)*((Math.abs(num)/(1000*1000)).toFixed(1)) + 'kk'
    }
    else if (value >= 1000)
    {
        value = Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k'
    }
    else
    {
        value = Number(value).toFixed(0);
    };

    return value;
};


export function fnDynamicLoad () {
	try {
		let is_last_page_element = document.getElementById("is_last_page_element");

		if (!is_last_page_element) {
			$(window).on('scroll', fnScroll);
		}

		let is_fetching = false;

		function fnScroll () {
			//console.log(`${$(window).scrollTop() + $(window).height()} > ${$(document).height() - 1}`);
		
			if($(window).scrollTop() + $(window).height() >= $(document).height() - 5) {
				GetRecords();
			}
		};

		let page_number = 1;

		function GetRecords() {
			if (is_fetching) {return;}

			is_fetching = true;
			page_number++;

			//console.log("GetRecords function calling, page_number: " + page_number);

			let lookup_address = $("#search_table").data('url');
				lookup_address = `${lookup_address}&page_number=${page_number}`

			$.ajax({
				type: "GET",
				url: lookup_address,
				//data: data_parameters,
				//async: false,
				dataType: "html",
				beforeSend: function() {
					$("#loader").show();
				},
				success: OnSuccess,
				failure: function(response) {
					console.log(response.d);
					$("#loader").hide();
				},
				error: function(response) {
					console.log(response.d);
					$("#loader").hide();
				}
			});

			is_fetching = false;
		}
	} catch (e) {
		if (e instanceof TypeError) {
			printError(e, true);
		} else {
			printError(e, false);
		}
		
		console.error(e.name);    // logs 'Error'
	console.error(e.message); // logs 'The message', or a JavaScript error message
	};
};

function OnSuccess(response) {
	$("#search_table").append(response);

	//parse string to html
	//convert response to HTML to be able to search last_page_element there
	let parser = new DOMParser();
	let responseHtml = parser.parseFromString(response, 'text/html');
	let is_last_page_element = responseHtml.getElementById("is_last_page_element");

	// checking if existing last element in the response
	// if yes, turn off scrolling
	if (is_last_page_element) {
		$(window).off('scroll');
	}

	$("#loader").hide();
};

var printError = function(error, explicit) {
    console.log(`[${explicit ? 'EXPLICIT' : 'INEXPLICIT'}] ${error.name}: ${error.message}`);
};


    // jquery groupping data
    // var groupValues = data.reduce(function (obj, item) {
    //     obj[item['x']] = obj[item['x']] || [];
    //     obj[item['x']] = +obj[item['x']] + +item['y']; // add (+) before variable so it's cast to numeric 
    //     return obj;
    // }, {});
    
    // var groupData = Object.keys(groupValues).map(function (key) {
    //     return [key, groupValues[key]];
    // });
    
    // console.log(groupData);